import {Network} from "../../../network/Network";
import {ProductType} from "../../../models/product/ProductType";
import {INetworkComponent} from "../../../network/types/INetworkComponent";
import {HttpStatus} from "../../../network/status/HttpStatus";
import {
    ICommunityBusinessResponseIncoming
} from "../../../models/community/business/ICommunityBusinessResponseIncoming";
import {
    ICommunityBusinessLocationIncoming
} from "../../../models/community/business/ICommunityBusinessLocationIncoming";
import {
    ICommunityBusinessStatsIncoming
} from "../../../models/community/business/ICommunityBusinessStatsIncoming";
import {
    ICommunityBusinessReviewsStatsIncoming
} from "../../../models/community/business/ICommunityBusinessReviewsStatsIncoming";

export class CommunityBusinessService {

    public static dispose(): void {}

    public static init(): void {}

    public static async getBusiness(communityId: string, component?: INetworkComponent): Promise<ICommunityBusinessResponseIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/business/${communityId}`, component);
        return request?.data;
    }

    public static async getLocations(communityId: string, component?: INetworkComponent): Promise<ICommunityBusinessLocationIncoming[]> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/business/locations/${communityId}`, component);
        return request?.data;
    }

    public static async getStats(communityId: string, component?: INetworkComponent): Promise<ICommunityBusinessStatsIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/business/stats/${communityId}`, component);
        return request?.data;
    }

    // tout l'historique part en une lecture : changer de période à l'écran ne rappelle pas le serveur
    public static async getReviewsStats(communityId: string, component?: INetworkComponent): Promise<ICommunityBusinessReviewsStatsIncoming> {
        let request = await Network.get(ProductType.COMMUNITY, `/community/business/reviews/stats/${communityId}`, component);
        return request?.data;
    }

    public static async selectLocation(communityId: string, accountId: string, locationId: string, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/business/select/${communityId}`, {
            accountId: accountId,
            locationId: locationId
        }, component);

        return request?.status == HttpStatus.OK;
    }

    public static async disconnect(communityId: string, component?: INetworkComponent): Promise<boolean> {
        let request = await Network.post(ProductType.COMMUNITY, `/community/business/disconnect/${communityId}`, undefined, component);
        return request?.status == HttpStatus.OK;
    }
}
